import React, { useEffect, useState } from 'react';
import {
  Wrap,
  Tab,
  TabButton,
  List,
  ListItem,
  Score,
  ListWrapper,
  TextWrapper,
  Text,
  TeamLogo
} from './styled';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import VolleyballBroadcastStore from '../../../../store/score/BroadcastStore/volleyball';
import SportsTeamLogo from '../../../teamLogo';

const VolleyBallBroadCast = observer(({ gameData }) => {
  const { detail } = gameData;
  const { period, teams } = detail;

  const { id } = useParams();
  const [active, setActive] = useState(null);

  const { getBroadcast, closeSocket, data } = VolleyballBroadcastStore();

  useEffect(() => {
    getBroadcast(id);
    return () => {
      closeSocket();
    };
  }, []);

  const handleChangeSet = (changeSet) => {
    data.setSelectedPeriod(changeSet);
    setActive(changeSet);
  };

  let broadcastComps = [];
  if (data.getPeriodBroadcast !== null) {
    for (let [key, value] of Object.entries(data.getPeriodBroadcast)) {
      if (active === null) {
        broadcastComps.unshift(
          <ListComp key={key} data={value} teams={teams} />
        );
      } else {
        if (parseInt(key) === active) {
          broadcastComps.unshift(
            <ListComp key={key} data={value} teams={teams} />
          );
        }
      }
    }
  }

  return (
    <Wrap>
      <Tab>
        <div>
          <TabButton
            active={active === null}
            onClick={() => handleChangeSet(null)}
            disabled={false}
          >
            전체
          </TabButton>
          <TabButton
            active={active === 1}
            onClick={() => handleChangeSet(1)}
            disabled={period < 1}
          >
            1세트
          </TabButton>
          <TabButton
            active={active === 2}
            onClick={() => handleChangeSet(2)}
            disabled={period < 2}
          >
            2세트
          </TabButton>
          <TabButton
            active={active === 3}
            onClick={() => handleChangeSet(3)}
            disabled={period < 3}
          >
            3세트
          </TabButton>
          <TabButton
            active={active === 4}
            onClick={() => handleChangeSet(4)}
            disabled={period < 4}
          >
            4세트
          </TabButton>
          <TabButton
            active={active === 5}
            onClick={() => handleChangeSet(5)}
            disabled={period < 5}
          >
            5세트
          </TabButton>
        </div>
      </Tab>
      <ListWrapper>{broadcastComps}</ListWrapper>
    </Wrap>
  );
});

const ListComp = ({ data, teams }) => {
  return (
    <List>
      {data.map((value, key) => {
        return <ListItemComp data={value} teams={teams} />;
      })}
    </List>
  );
};

const teamNameState = {
  HOME: '',
  AWAY: ''
};
const ListItemComp = ({ data, teams }) => {
  const { eventTexts, score } = data;

  const [teamImages, setTeamImages] = useState(teamNameState);
  useEffect(() => {
    let teamData = teams;
    if (teamData !== undefined) {
      setTeamImages({
        HOME: teamData.home.imgPath,
        AWAY: teamData.away.imgPath
      });
    }
  }, [teams]);
  return (
    <ListItem>
      <Score>
        {score.home} - {score.away}
      </Score>
      <TextWrapper>
        {eventTexts.map((value, key) => {
          const { playText, locationType } = value;
          const isNotice = locationType === 'TOTAL';
          const teamImage = (!isNotice && teamImages[locationType]) || '';
          return (
            <Text key={key} isNotice={isNotice}>
              {!isNotice && (
                <TeamLogo>
                  {teamImage !== '' && (
                    <SportsTeamLogo
                      imgSize={'23'}
                      imgUrl={teamImage}
                      isLazy={true}
                    />
                  )}
                </TeamLogo>
              )}
              {playText}
            </Text>
          );
        })}
      </TextWrapper>
    </ListItem>
  );
};
export default VolleyBallBroadCast;
